import * as React from "react";
import { CurrencySymbolDictionary } from "../../../../../../../react-core/Enums/Dictionaries/CurrencySymbolDictionary";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import TableFilterDropdown from "../../../../../../../react-core/Html/Components/TableFilterDropdown";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { ToggleButtonTwoOptions } from "../../../../../../../react-core/Html/ToggleButtonTwoOptions";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { PerformanceSummaryClient } from "../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/PerformanceSummary";
import { PortfolioPerformanceSimpleReturnAndIRRClient } from "../../../../../../../Wrap/Api/PortfolioAnalysis/Performance/PortfolioPerformanceSimpleReturnAndIRR";
import { ContextType } from "../../../../../../../Wrap/Constants/Enums/ContextType";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { AssetClassType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { PerformanceMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { PerformanceIncomeDataView } from "../../../../../../../Wrap/Constants/Enums/Portfolio/Performance/PerformanceIncomeDataView";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ViewType } from "../../../../../../../Wrap/Mapping/PortfolioAnalysis/Investment/Enum/ViewType";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { CashTransactionTypes } from "../../../../../../../Wrap/Models/Domains/Transactions/Cash/CashTransactionTypes";
import { PerformanceIncomeModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PerformanceIncomeModel";
import { PortfolioPerformanceSummaryModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PortfolioPerformanceSummaryModel";
import { ProductGraphData } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/ProductGraphData";
import { ProductPerformanceModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/ProductPerformanceModel";
import { RealisedGainLossDetailModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/RealisedGainLossDetailModel";
import { UnRealisedGainLossDetailModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/UnRealisedGainLossDetailModel";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { MoneyHelper } from "../../../../../../Shared/Common/MoneyHelper";
import { DateRange } from "../../../../../../Shared/Components/DateRange";
import { ExcelExportAction } from "../../../../../../Shared/ExcelExport/Actions/ExcelExportAction";
import { ExcelExportButton } from "../../../../../../Shared/ExcelExport/ExcelExportButton";
import { LoadingSkeletonType } from "../../../../../../Shared/LoadingSkeleton/Contents";
import { LoadingSkeleton } from "../../../../../../Shared/LoadingSkeleton/LoadingSkeleton";
import { PermissionAction } from "../../../../../../Shared/Permission/Action/PermissionAction";
import { Permission } from "../../../../../../Shared/Permission/Permission";
import { TableColSettingsAction } from "../../../../../../Shared/TableColFilter/Action/Action";
import { defaultTableColEditor, TableColSettingKeys } from "../../../../../../Shared/TableColFilter/Resource/Content";
import { TableColSettingsStore } from "../../../../../../Shared/TableColFilter/Store/Variable";
import { TableColEditor } from "../../../../../../Shared/TableColFilter/TableColEditor";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { UserStore } from "../../../../../Stroes/Variable";
import { Urls } from "../../../../../Urls";
import { ColumnExplain } from "./Components/ColumnExplain";
import { getDetailsCol, DetailTable } from "./Components/DetailTable";
import { getIncomeInterestCol, getIncomeDividendCol, getIncomeTaxCol, IncomeTable } from "./Components/IncomeTable";
import { getRealisedCol, RealisedGainLossTable } from "./Components/RealisedGainLossTable";
import { SummaryTable } from "./Components/SummaryTable";
import { getUnRealisedCol, UnrealisedGainLossTable } from "./Components/UnrealisedGainLossTable";
import { PerformanceDataView, IncomeTableViewMap } from "./Resource/Contents";
import { ViewTypeArray, ViewTypeMap, AssetClassTypeArray, AssetClassTypeMap } from "../../Resource/Contents";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { defaultAccountMinDate } from "../../Resource/Content";
import {
    ConsolidatedAccountStore,
    PortfolioDashboardMultiSelectionStore,
    PortfolioDashboardStore,
} from "../../Store/Variable";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import { isConsolidate, selectedHeadAccounts } from "../Common/PortfolioDashboardHelper";
import { PresentationViewButton } from "../Common/PresentationViewButton";
import { PresentationContext } from "../Common/PresentationViewWrapper";
import { PortfolioDashboardPerformanceAction } from "./Action/Action";
import { PerformanceChart } from "./Components/PerformanceChart";
import {
    IProductPerformanceDetailModel,
    PortfolioDashboardPerformanceDetailStore,
    PortfolioDashboardPerformanceGraphStore,
    PortfolioDashboardPerformanceIncomeStore,
    PortfolioDashboardPerformanceRealisedGainLossStore,
    PortfolioDashboardPerformanceUnRealisedGainLossStore,
} from "./Store/Variable";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { DateOptions } from "../../../../../../Shared/Components/Resource/Contents";
import { portfolioDashboardTabEnum } from "../../Resource/Content";
import { Lightbox } from "../../../../../../../react-core/Html/Components/Lightbox";
import { TransactionEnum } from "../Transactions/Resource/Contents";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { InvestorType } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { Spinner } from "../../../../../../../react-core/Html/Spinner";

interface IPortfolioDashboardPerformanceState {
    userInfo: User;
    from: Date;
    to: Date;
    fromInception: boolean;
    dataView: PerformanceDataView;
    summaryData: Map<string, ProductPerformanceModel[]>;
    totalGainLossPercentage: number;
    closingValue: Money;
    realisedGainLossData: RealisedGainLossDetailModel[];
    unRealisedGainLossData: UnRealisedGainLossDetailModel[];
    performanceDetailsData: IProductPerformanceDetailModel[];
    graphData: ProductGraphData[];
    incomeData: PerformanceIncomeModel;
    tier: AssetClassType;
    view: ViewType;
    dateSelected: string;
    returnBasis: PerformanceMethod;
    isLoading: boolean;
    filter: { tier: AssetClassType; view: ViewType };
    isShowColExplain: boolean;
    incomeTableView: PerformanceIncomeDataView;
    colsettings: any[];
    subAccountsSelectedInGraph: string[];
    slideNumber: number;
    showReportPop: boolean;
    reportLinkAccount: ClientAccount;
    accountsForReport: ClientAccount[];
    isTableLoading: boolean;
    consolidateSimpleRetrunAndIRR: number;
    JointSimpleRetrunAndIRR: number;
}

interface IPortfolioDashboardPerformanceProps extends IPortfolioDashboardComponentProps {}

export class PortfolioDashboardPerformance extends PortfolioDashboardComponent<
    IPortfolioDashboardPerformanceProps,
    IPortfolioDashboardPerformanceState
> {
    constructor(props: IPortfolioDashboardPerformanceProps) {
        super(props);

        this.subscribeToStore(PortfolioDashboardPerformanceGraphStore, () => this.onPerformanceGraphStoreChange());
        this.subscribeToStore(PortfolioDashboardPerformanceDetailStore, () => this.onPerformanceDetailStoreChange());
        this.subscribeToStore(PortfolioDashboardPerformanceRealisedGainLossStore, () =>
            this.onPerformanceRealisedGainLossStoreChange()
        );
        this.subscribeToStore(PortfolioDashboardPerformanceUnRealisedGainLossStore, () =>
            this.onPerformanceUnRealisedGainLossStoreChange()
        );
        this.subscribeToStore(PortfolioDashboardPerformanceIncomeStore, () => this.onPerformanceIncomeStoreChange());
        this.subscribeToStore(TableColSettingsStore, () => this.ontableEditorStoreChange());
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    initState() {
        const initDateRange = DateRange.initializeDateRange(this.getSelectedAccountsInceptionDate());
        this.state = {
            userInfo: UserStore.getUserInfo(),
            from: initDateRange.from,
            to: initDateRange.to,
            isShowColExplain: false,
            dateSelected: initDateRange.dateSelected,
            fromInception: initDateRange.fromInception,
            tier: AssetClassType.Tier1,
            view: ViewType.Product,
            returnBasis: PerformanceMethod.Simple,
            dataView: PermissionAction.getPerformanceDropdownOptions()[0],
            isLoading: true,
            summaryData: new Map<string, ProductPerformanceModel[]>(),
            totalGainLossPercentage: 0,
            closingValue: MoneyHelper.getDefaultMoney(),
            realisedGainLossData: null,
            unRealisedGainLossData: null,
            performanceDetailsData: null,
            incomeData: null,
            graphData: null,
            filter: { tier: AssetClassType.Tier1, view: ViewType.Product },
            incomeTableView: PerformanceIncomeDataView.Interest,
            colsettings: null,
            subAccountsSelectedInGraph: [],
            slideNumber: 0,
            showReportPop: false,
            reportLinkAccount: null,
            accountsForReport: [],
            isTableLoading: true,
            consolidateSimpleRetrunAndIRR: 0,
            JointSimpleRetrunAndIRR: 0
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const indexIsBtnPresentationClicked = Object.keys(portfolioDashboardTabEnum).indexOf(
            portfolioDashboardTabEnum.Performance
        );
        if (this.props.isBtnPresentationClicked[indexIsBtnPresentationClicked]) {
            this.props.onPresentationViewStatusChange(
                portfolioDashboardTabEnum.Performance,
                this.props.isBtnPresentationClicked
            );
        } else {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                HierarchyLevelName.Customer,
                                this.props.customerid
                            ),
                        })
                        .performance.getUrl(),
                    pageTitle: `${document.title} - client - performance`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }
    }

    getDataBySelectionStore() {
        const selection = PortfolioDashboardMultiSelectionStore.getData();
        if (selection && selection.length > 0) {
            this.getData(selection, false);
        }
    }

    getData(selectedSubAccountHierarchyIds: string[], isSelectionChange = true) {
        const inceoptionDate = this.getSelectedAccountsInceptionDate();
        if (isSelectionChange) {
            const initDateRange = DateRange.initializeDateRange(inceoptionDate);
            this.setState({
                from: initDateRange.from,
                to: initDateRange.to,
                dateSelected: initDateRange.dateSelected,
                fromInception: initDateRange.fromInception,
            });
        }

        const { from, to, tier, dataView, returnBasis, view, fromInception } = this.state;
        const _from = JsonDateParser.toJsonDateNoOffset(from);
        const _to = JsonDateParser.toJsonDateNoOffset(to);

        const selectedHeadAccounts = this.getSelectedHeadAccountHierarchyIds();
        switch (dataView) {
            case PerformanceDataView.Summary:
                this.setState({
                    isTableLoading: true,
                    closingValue: MoneyHelper.getDefaultMoney(),
                    summaryData: new Map<string, ProductPerformanceModel[]>(),
                });
                if (isConsolidate()) {
                    const consolidatedAccountData = ConsolidatedAccountStore.getData();

                    new PortfolioPerformanceSimpleReturnAndIRRClient()
                        .get(
                            consolidatedAccountData.HierarchyId,
                            _from,
                            JsonDateParser.toJsonDateNoOffset(new Date(to.getFullYear(), to.getMonth(), to.getDate())),
                            returnBasis,
                            PortfolioDashboardMultiSelectionStore.getData(),
                            JsonDateParser.toJsonDateNoOffset(inceoptionDate),
                            true
                        )
                        .onSuccess((v) =>
                            this.setState({
                                totalGainLossPercentage: v.SimpleRetrunOrIRR,
                                consolidateSimpleRetrunAndIRR: v.SimpleRetrunOrIRR,
                            })
                        );
                }

                const performanceSummaryPromises = selectedHeadAccounts.map(
                    (value) =>
                        new Promise<PortfolioPerformanceSummaryModel>((resolve) => {
                            new PerformanceSummaryClient()
                                .get(
                                    value,
                                    _from,
                                    _to,
                                    fromInception,
                                    returnBasis,
                                    PortfolioDashboardMultiSelectionStore.getData()
                                )
                                .onSuccess((data) => {
                                    this.onPerformanceSummaryReturn(value, data, selectedHeadAccounts);
                                    resolve(data);
                                });
                        })
                );

                Promise.all(performanceSummaryPromises).then((results: PortfolioPerformanceSummaryModel[]) => {
                    const closingValueTotal = results.reduce((total, current) => {
                        if (current.ClosingValue && current.ClosingValue.Currency != 0) {
                            return MoneyHelper.add(total, current.ClosingValue);
                        } else {
                            return total;
                        }
                    }, MoneyHelper.getDefaultMoney());

                    this.setState({ closingValue: closingValueTotal });
                    
                    const clientData = PortfolioDashboardStore.getData();
                    const individuleHeadAccount = clientData.find(x => x.InvestorType === InvestorType.Individual);

                    if (!individuleHeadAccount?.SubAccounts) return;

                    const subAccountIds = individuleHeadAccount.SubAccounts
                        .map(sa => sa.ClAccountId)
                        .filter((id): id is string => !!id);


                    const matchedPercentage = results.reduce<number | undefined>((found, summary) => {

                        if (found !== undefined) return found;

                        const hasMatch = summary.ProductPerformanceSummary.some(perf =>
                            perf.ClAccountId && subAccountIds.includes(perf.ClAccountId)
                        );

                        return hasMatch ? summary.TotalGainLossPercentage : found;
                    }, undefined);

                    this.setState({
                        JointSimpleRetrunAndIRR: matchedPercentage
                    });
                });

                PortfolioDashboardPerformanceAction.getPerformanceGraphData(
                    selectedHeadAccounts,
                    selectedSubAccountHierarchyIds,
                    _from,
                    _to,
                    fromInception
                );

                break;
            case PerformanceDataView.Detail:
                return PortfolioDashboardPerformanceAction.getPerformanceDetail(
                    selectedHeadAccounts,
                    selectedSubAccountHierarchyIds,
                    _from,
                    _to,
                    returnBasis,
                    tier,
                    view,
                    fromInception,
                    () => {
                        this.setState({ isTableLoading: false });
                    }
                );
            case PerformanceDataView.RealisedGainLoss:
                return PortfolioDashboardPerformanceAction.getPerformanceRealisedGainLoss(
                    selectedSubAccountHierarchyIds,
                    _from,
                    _to,
                    fromInception
                );
            case PerformanceDataView.UnrealisedGainLoss:
                return PortfolioDashboardPerformanceAction.getPerformanceUnRealisedGainLoss(
                    selectedSubAccountHierarchyIds,
                    _from,
                    _to,
                    fromInception
                );
            case PerformanceDataView.Income:
                return PortfolioDashboardPerformanceAction.getPerformanceIncomeData(
                    selectedHeadAccounts,
                    selectedSubAccountHierarchyIds,
                    _from,
                    _to,
                    this.state.incomeTableView,
                    fromInception
                );
            default:
                break;
        }
    }
    toggleFilter = null;

    private onPerformanceSummaryReturn(
        hierarchyId: string,
        data: PortfolioPerformanceSummaryModel,
        selectedHeadAccounts: string[]
    ) {
        const { summaryData, closingValue } = this.state;
        summaryData.set(hierarchyId, data.ProductPerformanceSummary);

        const uniqueSelectedHeadAccounts = new Set(selectedHeadAccounts);
        this.setState({
            summaryData: summaryData,
            isTableLoading: summaryData.size != uniqueSelectedHeadAccounts.size,
            totalGainLossPercentage: data.TotalGainLossPercentage,
        });
    }

    onPerformanceGraphStoreChange(): void {
        const data = PortfolioDashboardPerformanceGraphStore.getData();
        const subAccountsSelectedInGraph = data?.map((x) => {
            if (x.SubAccountType != SubAccountType.CashAccount && x.SubAccountType != SubAccountType.WrapCash) {
                return x.ClAccountId;
            }
        });
        this.setState({
            isLoading: false,
            graphData: data,
            subAccountsSelectedInGraph: subAccountsSelectedInGraph || [],
        });
    }

    onPerformanceDetailStoreChange(): void {
        this.setState({ isLoading: false, performanceDetailsData: PortfolioDashboardPerformanceDetailStore.getData() });
    }

    onPerformanceIncomeStoreChange(): void {
        this.setState({ isLoading: false, incomeData: PortfolioDashboardPerformanceIncomeStore.getData() });
    }
    onPerformanceUnRealisedGainLossStoreChange(): void {
        this.setState({
            isLoading: false,
            unRealisedGainLossData: PortfolioDashboardPerformanceUnRealisedGainLossStore.getData(),
        });
    }
    onPerformanceRealisedGainLossStoreChange(): void {
        this.setState({
            isLoading: false,
            realisedGainLossData: PortfolioDashboardPerformanceRealisedGainLossStore.getData(),
        });
    }
    private ontableEditorStoreChange() {
        const data = TableColSettingsStore.getData();
        const colEditorKey = this.GetTableColSettingKeys(this.state.dataView, this.state?.incomeTableView);
        if (JSON.stringify(data) == "{}") {
            TableColSettingsAction.post(defaultTableColEditor);
        } else if (data[colEditorKey].length == 0) {
            TableColSettingsAction.post(defaultTableColEditor[colEditorKey], colEditorKey);
        }
        this.setState({ colsettings: data[PerformanceDataView.Detail] });
    }

    getSettings() {
        const colEditorKey = TableColSettingKeys.PerformanceDetails;
        const _settings = JSON.parse(JSON.stringify(TableColSettingsStore.getData()));
        if (!_settings) {
            TableColSettingsAction.get(colEditorKey);
        } else if (JSON.stringify(_settings) == "{}") {
            TableColSettingsAction.post(defaultTableColEditor);
        } else if (_settings[colEditorKey] == []) {
            TableColSettingsAction.post(defaultTableColEditor[colEditorKey], colEditorKey);

            return defaultTableColEditor[colEditorKey];
        } else {
            return _settings[colEditorKey];
        }
    }

    initSetting() {
        if (this.state.dataView == PerformanceDataView.Summary) {
            return;
        }

        const colEditorKey = this.GetTableColSettingKeys(this.state.dataView, this.state?.incomeTableView);
        TableColSettingsAction.get(colEditorKey);
    }

    private getModel(ids, isToogle, productIndex, modelId) {
        const { from, to, tier, returnBasis, view, fromInception } = this.state;
        let _from = from;
        let _to = to;

        if (fromInception) {
            _from = new Date(from);
            _from.setDate(_from.getDate() - 1);
        }

        const fromJson = JsonDateParser.toJsonDateNoOffset(_from);
        const toJson = JsonDateParser.toJsonDateNoOffset(_to);
        PortfolioDashboardPerformanceAction.getDetailMPDetail(
            isToogle,
            productIndex,
            fromJson,
            toJson,
            returnBasis,
            tier,
            view,
            ids,
            (data) => this.setState({ performanceDetailsData: data }),
            modelId
        );
    }

    private GetTableColSettingKeys(dataView: PerformanceDataView, incomeView?: PerformanceIncomeDataView): string {
        switch (dataView) {
            case PerformanceDataView.Detail:
                return TableColSettingKeys.PerformanceDetails;
            case PerformanceDataView.RealisedGainLoss:
                return TableColSettingKeys.RealisedGainLoss;
            case PerformanceDataView.UnrealisedGainLoss:
                return TableColSettingKeys.UnRealisedGainLoss;
            case PerformanceDataView.Income:
                switch (incomeView) {
                    case PerformanceIncomeDataView.Interest:
                    case PerformanceIncomeDataView.AccumulationFundInterestNonCash:
                        return TableColSettingKeys.IncomeInterest;
                    case PerformanceIncomeDataView.Dividends:
                    case PerformanceIncomeDataView.AccumulationFundDistributionsNonCash:
                    case PerformanceIncomeDataView.EquityDividends:
                        return TableColSettingKeys.IncomeDividend;
                    case PerformanceIncomeDataView.Tax:
                        return TableColSettingKeys.IncomeTax;
                }
        }
        return "";
    }

    private GetCol(): any[] {
        let currencyCode = "";
        switch (this.state.dataView) {
            case PerformanceDataView.Detail:
                return getDetailsCol(this.getDetailTableProps());

            case PerformanceDataView.RealisedGainLoss:
                currencyCode = CurrencySymbolDictionary.getStringMap(
                    this.state.realisedGainLossData && this.state.realisedGainLossData.length > 0
                        ? this.state.realisedGainLossData[0]?.CostInBaseCurrency.Currency
                        : CurrencyCode.GBP
                );
                return getRealisedCol(currencyCode);
            case PerformanceDataView.UnrealisedGainLoss:
                currencyCode = CurrencySymbolDictionary.getStringMap(
                    this.state.unRealisedGainLossData && this.state.unRealisedGainLossData.length > 0
                        ? this.state.unRealisedGainLossData[0]?.CostInBaseCurrency.Currency
                        : CurrencyCode.GBP
                );
                return getUnRealisedCol(currencyCode);

            case PerformanceDataView.Income:
                currencyCode = CurrencySymbolDictionary.getStringMap(
                    this.state.incomeData != null ? this.state.incomeData.BaseCcy : CurrencyCode.GBP
                );
                switch (this.state.incomeTableView) {
                    case PerformanceIncomeDataView.Interest:
                    case PerformanceIncomeDataView.AccumulationFundInterestNonCash:
                        return getIncomeInterestCol(currencyCode);
                    case PerformanceIncomeDataView.Dividends:
                    case PerformanceIncomeDataView.AccumulationFundDistributionsNonCash:
                    case PerformanceIncomeDataView.EquityDividends:
                        return getIncomeDividendCol(currencyCode);
                    case PerformanceIncomeDataView.Tax:
                        return getIncomeTaxCol(currencyCode);
                }
        }
        return [];
    }

    private getDetailTableProps = () => {
        return {
            switchTab: (view) => this.setState({ dataView: view }, () => this.getDataBySelectionStore()),
            getModel: (instrumentIds, isToogle, productIndex, modelId) =>
                this.getModel(instrumentIds, isToogle, productIndex, modelId),
            data: this.state.performanceDetailsData,
            return: this.state.returnBasis,
            view: this.state.view,
            assetType: this.state.tier,
            colSetting: this.getSettings(),
            isLoading: this.state.isTableLoading,
        };
    };

    private showDataView() {
        const clientData = PortfolioDashboardStore.getData();
        const jointHeadAccount = clientData.find(x => x.InvestorType === InvestorType.JointIndividual)

        switch (this.state.dataView) {
            case PerformanceDataView.Summary:
                const selection = this.getSelectedSubAccountIds();
                const summaryDataRebuilt: PortfolioPerformanceSummaryModel = {
                    ProductPerformanceSummary: [],
                    ClosingValue: MoneyHelper.getDefaultMoney(),
                    OpeningValue: MoneyHelper.getDefaultMoney(),
                    TotalGainLoss: MoneyHelper.getDefaultMoney(),
                    MoneyIn: MoneyHelper.getDefaultMoney(),
                    MoneyOut: MoneyHelper.getDefaultMoney(),
                    AccountTransfer: MoneyHelper.getDefaultMoney(),
                    TotalGainLossPercentage: 0,
                };
                const { summaryData } = this.state;
                summaryData.forEach((value, key) => {
                    value.forEach((summary) => {
                        if (selection.some((x) => x == summary.ClAccountId)) {
                            summaryDataRebuilt.ProductPerformanceSummary.push(summary);
                            summaryDataRebuilt.OpeningValue = MoneyHelper.add(
                                summaryDataRebuilt.OpeningValue,
                                MoneyHelper.getMoneyWithProperFormat(summary.OpeningValue)
                            );
                            summaryDataRebuilt.TotalGainLoss = MoneyHelper.add(
                                summaryDataRebuilt.TotalGainLoss,
                                MoneyHelper.getMoneyWithProperFormat(summary.TotalGainLoss)
                            );
                            summaryDataRebuilt.MoneyIn = MoneyHelper.add(
                                summaryDataRebuilt.MoneyIn,
                                MoneyHelper.getMoneyWithProperFormat(summary.MoneyIn)
                            );
                            summaryDataRebuilt.MoneyOut = MoneyHelper.add(
                                summaryDataRebuilt.MoneyOut,
                                MoneyHelper.getMoneyWithProperFormat(summary.MoneyOut)
                            );
                            summaryDataRebuilt.AccountTransfer = MoneyHelper.add(
                                summaryDataRebuilt.AccountTransfer,
                                MoneyHelper.getMoneyWithProperFormat(summary.AccountTransfer)
                            );
                        }
                    });
                });
                const portfolioValue = summaryDataRebuilt.OpeningValue.Amount + summaryDataRebuilt.MoneyIn.Amount + summaryDataRebuilt.MoneyOut.Amount + summaryDataRebuilt.AccountTransfer.Amount;
                summaryDataRebuilt.ClosingValue = MoneyHelper.getMoneyWithProperFormat(this.state.closingValue);
                let percentage: number;

                if (isConsolidate()) {
                    percentage = this.state.consolidateSimpleRetrunAndIRR * 100;
                } else if (jointHeadAccount && this.state.returnBasis === PerformanceMethod.IRR) {
                    percentage = (this.state.JointSimpleRetrunAndIRR ?? 0);
                } else if (this.state.returnBasis === PerformanceMethod.Simple && portfolioValue !== 0) {
                    const simpleReturn = summaryDataRebuilt.TotalGainLoss.Amount / portfolioValue;
                    percentage = MoneyHelper.roundNumberToDecimalPlaces(simpleReturn, 4) * 100;
                } else {
                    percentage = this.state.totalGainLossPercentage;
                }
                summaryDataRebuilt.TotalGainLossPercentage = percentage;

                return (
                    <Permission userClaim={UserClaim.AdviserPortalPerformanceSummaryCanView}>
                        <SummaryTable
                            navigationToTab={(
                                tab,
                                transTypeSelect: TransactionEnum,
                                transactionType: CashTransactionTypes
                            ) => {
                                this.navigateToTransaction(tab, transTypeSelect, transactionType);
                            }}
                            data={summaryDataRebuilt}
                            isTableLoading={this.state.isTableLoading}
                            return={this.state.returnBasis}
                            from={JsonDateParser.getFormatDateString(this.state.from, "dd-MM-yyyy", true, true)}
                            to={JsonDateParser.getFormatDateString(this.state.to, "dd-MM-yyyy", true, true)}
                            claccountid={this.getHeadClAccountId()}
                            subaccountClaccountids={selection}
                            selectedHeadClAccountIds={this.getSelectedHeadClAccountIds()}
                        />
                    </Permission>
                );

            case PerformanceDataView.Detail:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalPerformanceDetailCanView}>
                        <DetailTable {...this.getDetailTableProps()} />
                    </Permission>
                );
            case PerformanceDataView.RealisedGainLoss:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalRealisedGainLossCanView}>
                        <RealisedGainLossTable data={this.state.realisedGainLossData} />
                    </Permission>
                );
            case PerformanceDataView.UnrealisedGainLoss:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalUnrealisedGainLossCanView}>
                        <UnrealisedGainLossTable data={this.state.unRealisedGainLossData} />
                    </Permission>
                );
            case PerformanceDataView.Income:
                return (
                    <Permission userClaim={UserClaim.AdviserPortalPerformanceIncomeCanView}>
                        <IncomeTable
                            data={this.state.incomeData}
                            tableView={this.state.incomeTableView}
                            editorKey={this.GetTableColSettingKeys(
                                PerformanceDataView.Income,
                                this.state.incomeTableView
                            )}
                        />
                    </Permission>
                );
            default:
                return null;
        }
    }

    private navigateToTransaction(tab, transTypeSelect: TransactionEnum, transactionType: CashTransactionTypes) {
        if (checkPermission(PermissionAction.getTransactionPermissionMap()[transTypeSelect])) {
            Navigator.navigateTo(
                Urls.get().main.PortfolioDashboard({
                    hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                }).transactions,
                {
                    scrollAfterNavigating: true,
                    queryParamsObject: {
                        transtypeselect: transTypeSelect,
                        from: this.state.from,
                        to: this.state.to,
                        dateSelected: this.state.dateSelected,
                        fromInception: this.state.fromInception,
                        cashTransactionType: transactionType,
                    },
                }
            );
        }
    }

    private handleLaunchpadClick() {
        const context: Record<string, string> = {};

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {
            context.customerId = customerHierarchyId;
        }

        (window as any).AppStore.open(context);
    }

    private getHeadClAccountId() {
        if (isConsolidate()) {
            return ConsolidatedAccountStore.getData().HeadClAccountId;
        } else {
            return this.getSelectedHeadClAccountIds()[0];
        }
    }
    
    private getSummaryProducts(): any[] {
        const {summaryData} = this.state;
        let summaryProducts  = [];

       summaryData.forEach(summary => {
        summary.forEach(item=>{
            summaryProducts.push({
                ClAccountId: (item as any).ClAccountId,
                ProductDisplayName: (item as any).ProductDisplayName
            });
        })
            
        })
        return summaryProducts;
    }

    public render(): JSX.Element {
        const { isLoading, from, to, dateSelected, dataView, returnBasis, userInfo } = this.state;
        const { isPresentationView } = this.context;
        const minDate = this.getSelectedAccountsInceptionDate();
        const isFundzoneOnly =
            userInfo?.ServiceProposition?.length == 1 &&
            userInfo?.ServiceProposition?.filter((x) => x == ServiceProposition.Fundzone)?.length != 0;
        const isAppStoreEnabled = this.state.userInfo?.IsAppStoreEnabledForUser;

        return (
            <div role={isPresentationView ? "main" : "tabpanel"} id="panel-2" tabIndex={0} aria-labelledby="tab-2">
                <div className="ad d1">
                    <div className="row">
                        <div className="col-8">
                            <DateRange
                                disabled={minDate.getFullYear() == defaultAccountMinDate.getFullYear()}
                                minDate={minDate}
                                fromDate={from}
                                toDate={to}
                                cssGridDate="col-12 col-sm-auto"
                                cssGridTo="col-12 col-sm-auto"
                                cssGridFrom="col-12 col-sm-auto"
                                cssGridLabel="col-12 col-sm-auto col-middle"
                                selectValue={dateSelected}
                                onChange={(
                                    fromDate: Date,
                                    toDate: Date,
                                    fromInception: boolean,
                                    dateSelected: string
                                ) => {
                                    this.addEvent({
                                        event: "performancetab_interaction",
                                        eventParameters: {
                                            eventCategory: eventCategoryForGTM.performanceTab,
                                            eventAction: "date range selector",
                                            eventLabel: CommonHelper.getOptionsTxt(
                                                dateSelected,
                                                DateOptions
                                            ).toLowerCase(),
                                        },
                                    });
                                    this.setState(
                                        {
                                            from: fromDate,
                                            to: toDate,
                                            dateSelected: dateSelected,
                                            fromInception: fromInception,
                                            isLoading: true,
                                            closingValue: MoneyHelper.getDefaultMoney(),
                                        },
                                        () => this.getDataBySelectionStore()
                                    );
                                }}
                            />
                        </div>
                        <div className="col-4 col-right">
                            <div className="row row-right">
                                <Permission userClaim={UserClaim.AdviserPortalClientPortfolioReportReadWrite}>
                                    <div className="col-auto">
                                        <button
                                            type="button"
                                            className="document-button"
                                            onClick={() => {
                                                this.addEvent({
                                                    event: "performancetab_interaction",
                                                    eventParameters: {
                                                        eventCategory: eventCategoryForGTM.performanceTab,
                                                        eventAction: "interactions",
                                                        eventLabel: "create client portfolio report",
                                                    },
                                                });
                                                let headAccounts = selectedHeadAccounts(
                                                    PortfolioDashboardMultiSelectionStore.getData(),
                                                    PortfolioDashboardStore.getData()
                                                );
                                                if (isConsolidate()) {
                                                    headAccounts = [ConsolidatedAccountStore.getData()].concat(
                                                        headAccounts
                                                    );
                                                }
                                                if (headAccounts.length == 1) {
                                                    if (
                                                        checkPermission(
                                                            UserClaim.AdviserPortalClientPortfolioReportReadWrite
                                                        )
                                                    ) {
                                                        Navigator.navigateTo(
                                                            Urls.get()
                                                                .main.PortfolioDashboard({
                                                                    hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                                        ContextType.Customer
                                                                    ),
                                                                })
                                                                .clientReport({
                                                                    headaccounthierarchyId:
                                                                        headAccounts[0]?.HierarchyId,
                                                                }).clientReport
                                                        );
                                                    }
                                                } else {
                                                    this.setState({
                                                        showReportPop: true,
                                                        accountsForReport: headAccounts,
                                                    });
                                                }
                                            }}
                                        >
                                            <span className="icon" aria-hidden="true"></span>Create client portfolio
                                            report
                                        </button>
                                    </div>
                                </Permission>

                                <div className="col-auto col-right">
                                    <PresentationViewButton
                                        onClick={() => {
                                            this.addEvent({
                                                event: "performancetab_interaction",
                                                eventParameters: {
                                                    eventCategory: eventCategoryForGTM.performanceTab,
                                                    eventAction: "interactions",
                                                    eventLabel: "presentation mode",
                                                },
                                            });
                                            this.props.onPresentationViewStatusChange(
                                                portfolioDashboardTabEnum.Performance,
                                                this.props.isBtnPresentationClicked
                                            );
                                        }}
                                    />
                                </div>
                                {isAppStoreEnabled && (
                                    <div className="col-auto col-right">
                                        <button
                                            type="button"
                                            className="applications-pad-button"
                                            onClick={this.handleLaunchpadClick.bind(this)}
                                        >
                                            <span className="sr-only">Applications pad</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-fluid col-max-245">
                            <SelectEditor
                                disabled={isFundzoneOnly}
                                id="DataView"
                                label="Choose data view"
                                selected={dataView}
                                options={PermissionAction.getPerformanceDropdownOptions()}
                                getText={(o) => o}
                                onChange={(e) => {
                                    this.addEvent({
                                        event: "performancetab_interaction",
                                        eventParameters: {
                                            eventCategory: eventCategoryForGTM.performanceTab,
                                            eventAction: "data view selector",
                                            eventLabel: e.toLowerCase(),
                                        },
                                    });
                                    if (e === PerformanceDataView.Charges) {
                                        Navigator.navigateTo(
                                            Urls.get().main.PortfolioDashboard({
                                                hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                            }).transactions,
                                            {
                                                scrollAfterNavigating: true,
                                                queryParamsObject: {
                                                    transtypeselect: TransactionEnum.charges,
                                                },
                                            }
                                        );
                                    } else {
                                        this.setState({ dataView: e, isLoading: true }, () => {
                                            this.getDataBySelectionStore();
                                            this.initSetting();
                                        });
                                    }
                                }}
                            />
                        </div>
                        {(dataView == PerformanceDataView.Summary || dataView == PerformanceDataView.Detail) && (
                            <div className="col-12 col-sm-fluid col-max-245">
                                <ToggleButtonTwoOptions
                                    optionOne="Simple return"
                                    optionTwo="IRR"
                                    label={"Return basis"}
                                    tooltip={true}
                                    value={returnBasis == PerformanceMethod.IRR}
                                    onChange={(v) => {
                                        this.addEvent({
                                            event: "performancetab_interaction",
                                            eventParameters: {
                                                eventCategory: eventCategoryForGTM.performanceTab,
                                                eventAction: "return basis",
                                                eventLabel: v ? "irr" : "simple",
                                            },
                                        });
                                        this.setState(
                                            {
                                                returnBasis: v ? PerformanceMethod.IRR : PerformanceMethod.Simple,
                                                isTableLoading: true,
                                            },
                                            () => this.getDataBySelectionStore()
                                        );
                                    }}
                                />
                            </div>
                        )}
                        {dataView == PerformanceDataView.Income && (
                            <div className="col-12 col-sm-fluid col-max-245">
                                <SelectEditor
                                    options={Object.keys(IncomeTableViewMap).map((e) => Number(e))}
                                    getText={(v) => {
                                        return IncomeTableViewMap[v];
                                    }}
                                    label={"Data table"}
                                    selected={PerformanceIncomeDataView.Interest}
                                    onChange={(v) => {
                                        this.setState(
                                            {
                                                incomeTableView: v,
                                                isLoading: true,
                                            },
                                            () => {
                                                this.getDataBySelectionStore();
                                                this.initSetting();
                                            }
                                        );
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    {isLoading ? (
                        <div className="text-center">
                            <h3>Performance details loading</h3>
                            <p>This may take a few moments. Please do not move away from this page.</p>
                            <Spinner notFull={true} />
                        </div>
                    ) : (
                        <div>
                            {dataView == PerformanceDataView.Summary && (
                                <div className="panel">
                                    {" "}
                                    Valuation and Money Movements
                                    <PerformanceChart
                                        data={this.GetPerformanceChartData()}
                                        selectedProducts={this.state.subAccountsSelectedInGraph}
                                        summaryProducts={this.getSummaryProducts()}
                                        onClickGraghSeriesBtn={(clAccountId: string) =>
                                            this.onClickGraghSeriesBtn(clAccountId)
                                        }
                                    />
                                </div>
                            )}
                            <div className="row row-right mb-12">
                                {dataView == PerformanceDataView.Summary || dataView == PerformanceDataView.Detail ? (
                                    <>
                                        {!isPresentationView && (
                                            <div className="col-auto col-middle">
                                                <button
                                                    type="button"
                                                    className="hyperlink"
                                                    onClick={() => {
                                                        this.addEvent({
                                                            event: "performancetab_interaction",
                                                            eventParameters: {
                                                                eventCategory: eventCategoryForGTM.performanceTab,
                                                                eventAction: "interactions",
                                                                eventLabel: "columns explained",
                                                            },
                                                        });
                                                        this.setState({ isShowColExplain: true });
                                                    }}
                                                >
                                                    Columns explained
                                                </button>
                                            </div>
                                        )}
                                        {this.state.summaryData &&
                                            dataView == PerformanceDataView.Summary &&
                                            this.state.summaryData?.size != 0 ? (
                                            <div className="col-auto col-middle">
                                                <ExcelExportButton
                                                    onRequestReport={() => {
                                                        this.addEvent({
                                                            event: "performancetab_interaction",
                                                            eventParameters: {
                                                                eventCategory: eventCategoryForGTM.performanceTab,
                                                                eventAction: "interactions",
                                                                eventLabel: "export to excel",
                                                            },
                                                        });
                                                        switch (dataView) {
                                                            case PerformanceDataView.Summary:
                                                                //TODO
                                                                return ExcelExportAction.generatePerformanceSummaryReport(
                                                                    PortfolioDashboardMultiSelectionStore.getData(),
                                                                    to,
                                                                    from,
                                                                    this.state.fromInception,
                                                                    returnBasis,
                                                                    this.props.customerid,
                                                                    HierarchyIdHelper.generateHierarchyId(
                                                                        ContextStore.getUrlParamsHierarchyId(
                                                                            ContextType.Customer
                                                                        )
                                                                    ).hierarchyLevel == HierarchyLevelName.Customer
                                                                        ? ""
                                                                        : ContextStore.getUrlParamsHierarchyId(
                                                                            ContextType.Customer
                                                                        )
                                                                );
                                                        }
                                                    }}
                                                    selectedAccount={null}
                                                ></ExcelExportButton>
                                            </div>
                                        ) : null}
                                    </>
                                ) : null}
                                {dataView === PerformanceDataView.Detail && (
                                    <div className="col-auto">
                                        <TableFilterDropdown
                                            cssWrapper="table-default-filter"
                                            labelSrOnly="Open the table filter dropdown"
                                            onOpen={(e) => (this.toggleFilter = e)}
                                            title="Filter table"
                                        >
                                            <div>
                                                <RadiosEditor
                                                    cssWrapper="rg-inline mb-10"
                                                    label="Filter table by"
                                                    labelGridClasses="text-size-16 text-bold mb-10 text-text"
                                                    options={ViewTypeArray}
                                                    getText={(v) => {
                                                        return ViewTypeMap[v];
                                                    }}
                                                    selected={this.state.filter.view}
                                                    onChange={(v) =>
                                                        this.setState((preState) => {
                                                            return {
                                                                filter: { tier: preState.filter.tier, view: v },
                                                            };
                                                        })
                                                    }
                                                />
                                                <RadiosEditor
                                                    cssWrapper="rg-inline mb-20"
                                                    options={AssetClassTypeArray}
                                                    getText={(v) => {
                                                        return AssetClassTypeMap[v];
                                                    }}
                                                    selected={this.state.filter.tier}
                                                    onChange={(v) =>
                                                        this.setState((preState) => {
                                                            return {
                                                                filter: { tier: v, view: preState.filter.view },
                                                            };
                                                        })
                                                    }
                                                />
                                                <div className="row narrow-gutter">
                                                    <div
                                                        className="col-fluid text-right"
                                                        onClick={() => {
                                                            this.setState({
                                                                filter: {
                                                                    tier: this.state.tier,
                                                                    view: this.state.view,
                                                                },
                                                            });
                                                            this.toggleFilter(true);
                                                        }}
                                                    >
                                                        <button className="btn secondary block-xxs">Cancel</button>
                                                    </div>
                                                    <div
                                                        className="col-auto"
                                                        onClick={() => {
                                                            this.toggleFilter(true);
                                                            this.setState(
                                                                {
                                                                    tier: this.state.filter.tier,
                                                                    view: this.state.filter.view,
                                                                },
                                                                () => this.getDataBySelectionStore()
                                                            );
                                                        }}
                                                    >
                                                        <button className="btn primary block-xxs ml-8">Apply</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </TableFilterDropdown>
                                    </div>
                                )}
                                {dataView !== PerformanceDataView.Summary && (
                                    <TableColEditor
                                        tableEditorKey={this.GetTableColSettingKeys(
                                            dataView,
                                            this.state.incomeTableView
                                        )}
                                        title="Table editor"
                                        col={this.GetCol()}
                                        disableDrag={true}
                                    />
                                    // <TableColEditor
                                    //     tableEditorKey={this.GetTableColSettingKeys(dataView, this.state.incomeTableView)}
                                    //     col={}
                                    //     disableDrag={true}
                                    // />
                                )}
                            </div>
                            Performance
                            {this.showDataView()}
                        </div>
                    )}
                    {this.state.isShowColExplain && (
                        <Lightbox
                            title="Columns explained"
                            show={this.state.isShowColExplain}
                            cssWrapper="is-default-lightbox"
                            onClose={() => this.setState({ isShowColExplain: false })}
                        >
                            <ColumnExplain performanceMethod={returnBasis} dataView={dataView} />
                        </Lightbox>
                    )}
                    {this.state.showReportPop && (
                        <Lightbox
                            title="Select an account to create report"
                            show={this.state.showReportPop}
                            cssWrapper="is-default-lightbox"
                            onClose={() => this.setState({ showReportPop: false, reportLinkAccount: null })}
                        >
                            <SelectEditor
                                onChange={(v) => this.setState({ reportLinkAccount: v })}
                                options={this.state.accountsForReport}
                                placeholder="Please select"
                                selected={this.state.reportLinkAccount}
                                cssWrapper={"control-size-245"}
                                getText={(o) => o?.HeadClAccountId}
                            />
                            {checkPermission(UserClaim.AdviserPortalClientPortfolioReportReadWrite) && (
                                <button
                                    className="btn primary"
                                    disabled={this.state.reportLinkAccount == null}
                                    onClick={() =>
                                        Navigator.navigateTo(
                                            Urls.get()
                                                .main.PortfolioDashboard({
                                                    hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                        ContextType.Customer
                                                    ),
                                                })
                                                .clientReport({
                                                    headaccounthierarchyId: this.state.reportLinkAccount.HierarchyId,
                                                }).clientReport
                                        )
                                    }
                                >
                                    Create Client Portfolio Report
                                </button>
                            )}
                        </Lightbox>
                    )}
                </div>

                <div>
                    {!isPresentationView && checkPermission(UserClaim.AdviserPortalPerformanceChargesCanView) && (
                        <button
                            className="hyperlink"
                            onClick={() => {
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                    }).transactions,
                                    {
                                        scrollAfterNavigating: true,
                                        queryParamsObject: {
                                            transtypeselect: TransactionEnum.charges,
                                        },
                                    }
                                );
                            }}
                        >
                            View charges transactions
                        </button>
                    )}
                </div>
            </div>
        );
    }

    private GetPerformanceChartData(): ProductGraphData[] {
        if (!this.state.graphData) {
            return null;
        }
        const result = this.state.graphData?.filter((ele) => this.getSelectedSubAccountIds().includes(ele.ClAccountId));
        const { summaryData, to } = this.state;
        const today = new Date();
        if (today.toDateString() === to.toDateString()) {
            summaryData.forEach((value, key) => {
                value.forEach((summary) => {
                    const index = result.findIndex(function (c) {
                        return c.ClAccountId == summary.ClAccountId;
                    });
                    if (index > -1) {
                        result[index].GraphData[result[index].GraphData.length - 1].Value = summary.ClosingValue.Amount;
                    }
                });
            });
        }
        return result;
    }

    onClickGraghSeriesBtn(clAccountId: string) {
        const { subAccountsSelectedInGraph } = this.state;
        if (subAccountsSelectedInGraph.some((x) => x == clAccountId)) {
            this.setState({ subAccountsSelectedInGraph: subAccountsSelectedInGraph.filter((x) => x != clAccountId) });
        } else {
            this.setState({ subAccountsSelectedInGraph: [...subAccountsSelectedInGraph, clAccountId] });
        }
    }
}
PortfolioDashboardPerformance.contextType = PresentationContext;
